// import React from "react";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

// const data = [
//     { state: "AP AND TELANGANA", completed: 275, pending: 29, awaiting: 3, declined: 56, payroll: 56 },
//     { state: "CHENNAI", completed: 574, pending: 43, awaiting: 7, declined: 41, payroll: 41 },
//     { state: "COCHIN", completed: 7, pending: 4, awaiting: 0, declined: 4, payroll: 4 },
//     { state: "DELHI", completed: 2, pending: 7, awaiting: 12, declined: 2, payroll: 2 },
//     { state: "GOA", completed: 32, pending: 2, awaiting: 3, declined: 13, payroll: 13 },
//     { state: "KARNATAKA", completed: 572, pending: 40, awaiting: 0, declined: 111, payroll: 111 },
//     { state: "EAST", completed: 53, pending: 3, awaiting: 2, declined: 11, payroll: 11 },
//     { state: "GUJARAT", completed: 96, pending: 3, awaiting: 20, declined: 20, payroll: 20 },
//     { state: "KERALA", completed: 33, pending: 2, awaiting: 2, declined: 2, payroll: 2 },
//     { state: "MUMBAI", completed: 62, pending: 6, awaiting: 19, declined: 19, payroll: 19 },
// ];

// const ChartWithTable = () => {
//     return (
//         <div style={{ overflowX: "auto", whiteSpace: "nowrap", padding: "20px", background: "#fff" }}>
//             <h3 style={{ textAlign: "center", marginBottom: "10px" }}>KYC Status Overview</h3>

//             {/* Bar Chart */}
//             <div style={{ minWidth: "1000px" }}>
//                 <ResponsiveContainer width="100%" height={350}>
//                     <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="state" tick={{ fontSize: 12 }} />
//                         <YAxis />
//                         <Tooltip />
//                         <Legend />
//                         <Bar dataKey="completed" stackId="a" fill="#4CAF50" name="KYC COMPLETED" />
//                         <Bar dataKey="pending" stackId="a" fill="#FF7043" name="KYC Pending" />
//                         <Bar dataKey="awaiting" stackId="a" fill="#FFD54F" name="AWAITING RM APPROVAL" />
//                         <Bar dataKey="declined" stackId="a" fill="#E53935" name="Rejected or declined" />
//                         <Bar dataKey="payroll" stackId="a" fill="#AB47BC" name="Awaiting Payroll approval" />
//                     </BarChart>
//                 </ResponsiveContainer>
//             </div>

//             {/* Table Below */}
//             <div style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto", minWidth: "1000px", marginTop: "10px" }}>
//                 <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", minWidth: "1000px" }}>
//                     <thead style={{ position: "sticky", top: 0, background: "#ddd" }}>
//                         <tr>
//                             <th style={tableHeaderStyle}>State</th>
//                             <th style={tableHeaderStyle}>KYC COMPLETED</th>
//                             <th style={tableHeaderStyle}>KYC Pending</th>
//                             <th style={tableHeaderStyle}>AWAITING RM APPROVAL</th>
//                             <th style={tableHeaderStyle}>Rejected or declined</th>
//                             <th style={tableHeaderStyle}>Awaiting Payroll approval</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {data.map((row, index) => (
//                             <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
//                                 <td style={tableCellStyle}>{row.state}</td>
//                                 <td style={tableCellStyle}>{row.completed}</td>
//                                 <td style={tableCellStyle}>{row.pending}</td>
//                                 <td style={tableCellStyle}>{row.awaiting}</td>
//                                 <td style={tableCellStyle}>{row.declined}</td>
//                                 <td style={tableCellStyle}>{row.payroll}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// const tableHeaderStyle = {
//     padding: "10px",
//     borderBottom: "2px solid #444",
//     fontWeight: "bold",
//     background: "#f4f4f4",
//     position: "sticky",
//     top: 0
// };

// const tableCellStyle = {
//     padding: "10px",
//     borderBottom: "1px solid #ccc",
//     fontSize: "14px"
// };

// export default ChartWithTable;
import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useSelector } from "react-redux";
import DashboardTable from "../../AppComponent/Dashboardtable";
import boximg from "../../../Assets/AppComponent/Group 427320177.svg";

const ChartWithTable = () => {
    const dashboardData = useSelector((state) => state.NewDashboardNameHolds.NewDashboardRecords);

    // Extract unique state names dynamically
    const stateNames = [...new Set(dashboardData.map(item => item.FilterName))];

    // Transform data for the bar chart
    const chartData = stateNames.map(state => {
        const record = dashboardData.find(item => item.FilterName === state);
        return {
            state,
            completed: record.kyc_completed_count || 0,
            pending: record.kyc_pending_count || 0,
            awaiting: record.awaiting_rm_approval_count || 0,
            declined: record.rejected_count || 0,
            payroll: record.awaiting_payroll_approval_count || 0
        };
    });

    // Transform data for the table (pivot structure)
    const tableData = [
        { label: "KYC COMPLETED", values: chartData.map(row => row.completed) },
        { label: "KYC PENDING", values: chartData.map(row => row.pending) },
        { label: "AWAITING RM APPROVAL", values: chartData.map(row => row.awaiting) },
        { label: "REJECTED OR  DECLINED", values: chartData.map(row => row.declined) },
        // { label: "AWAITING PAYROLL APPROVAL", values: chartData.map(row => row.payroll) }
    ];
    console.log(chartData, "asdasd chartData", dashboardData

    );

    const tableHeaderStyle = {
        padding: "10px",
        borderBottom: "2px solid #ddd",
        fontWeight: "500",
        background: "#234492",
        position: "sticky",
        top: 0,
        color: "#fff"
    };

    const tableCellStyle = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "14px"
    };



    return (
        <>
            <div className="recordofChartDetails " style={{ overflowX: "auto", whiteSpace: "nowrap", padding: "20px", background: "#fff" }}>
                <h3 style={{ textAlign: "center", marginBottom: "10px" }}>KYC Status Overview</h3>

                {dashboardData.length > 0 ?

                    <>
                        <div style={{ minWidth: "1000px" }}>
                            <ResponsiveContainer width="100%" height={350} >
                                <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="state"
                                        tick={{ fontSize: 10, dy: 10 }}
                                        interval={0} 
                                        angle={-25}
                                        tickFormatter={(value) => value.length > 7 ? `${value.substring(0, 9)}...` : value}
                                    />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="completed" stackId="a" fill="#4CAF50" name="KYC COMPLETED" />
                                    <Bar dataKey="pending" stackId="a" fill="#FF7043" name="KYC Pending" />
                                    <Bar dataKey="awaiting" stackId="a" fill="#FFD54F" name="AWAITING RM APPROVAL" />
                                    <Bar dataKey="declined" stackId="a" fill="#E53935" name="Rejected or declined" />
                                    {/* <Bar dataKey="payroll" stackId="a" fill="#AB47BC" name="Awaiting Payroll approval" /> */}
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        {/* <DashboardTable /> */}
                        {/* Table Below */}
                        <div style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto", minWidth: "1000px", marginTop: "37px" }}>
                            <table className="TicketingTableOverviewsDashboard" style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", minWidth: "1000px" }}>
                                <thead style={{ position: "sticky", top: 0, background: "#234492" }}>
                                    <tr>
                                        <th style={tableHeaderStyle}>Status</th>
                                        {stateNames.map((state, index) => (
                                            <th key={index} style={tableHeaderStyle}>{state.length > 10 ? `${state.substring(0, 7)}...` : state}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((row, rowIndex) => (
                                        <tr key={rowIndex} style={{ borderottom: "1px solid #ccc" }}>
                                            <td style={tableCellStyle} className="LabelNamesstate">{row.label}</td>
                                            {row.values.map((value, index) => (
                                                <td key={index} style={tableCellStyle} className="RowDatasChanges" >{value}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>


                    </>

                    :

                    <div>
                        <div className="Dusbinback">
                            <div>
                                <img src={boximg} alt="No Status available" />
                                <p className="text-center">{"No Status available"}</p>
                            </div>
                        </div>
                    </div>
                }
            </div>


        </>
    );
};


export default ChartWithTable;
